module.exports = __webpack_public_path__ + "static/media/aqua3.87715fec.png";